import React from 'react'
import Sidebar from '../../components/Sidebar'
import Navbar from '../../components/Navbar'
import SiteLogsExportComponent from '../../components/SiteLogsExportComponent/SiteLogsExportComponent'

const SiteLogsExport = () => {
    return (
        <div>
            <div className='flex'>
                <div className='w-[15%]'>
                    <Sidebar />
                </div>
                <div>
                    <Navbar />
                    <SiteLogsExportComponent/>
                </div>
            </div>
        </div>
    )
}

export default SiteLogsExport
